import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
// import Spinner from '@/src/components/common/Elements/Spinner/Spinner';
import Spinner from '@/src/components/common/Elements/Spinner/Spinner';
import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import TagWorkstreamModal from '@/src/components/project/Common/Modals/TagWorkstreamModal/TagWorkstreamModal';
import { isResponseError } from '@/src/components/project/Inbox2/api/config';
import ActionButton from '@/src/components/project/Inbox2/Elements/ActionButton/ActionButton';
import { FileEntry } from '@/src/components/project/Inbox2/types';
import { showToast } from '@/src/globalFunction';
import {
  initialize,
  toggleModal,
} from '@/src/reducers/project/tagFileWorkstream/tagFileWorkstream.actions';
import { RootState } from '@/src/reducers/types';

import { useValidateActionResponse } from '../../../../../useValidateActionResponse';
import { useFileEntryViewerSidebarActions } from '../../../../store/fileEntryViewer.sidebarActions.store';

type TagFileWorkstreamProps = {
  fileEntry: FileEntry;
};

const TagFileWorkstream = ({ fileEntry }: TagFileWorkstreamProps) => {
  const { sidebarActions } = useFileEntryViewerSidebarActions();
  const tagFileWorkstreamMutation = sidebarActions.tagFileWorkstreamMutation;
  const dispatch = useDispatch();
  const showModal = useSelector((store: RootState) => store.tagFileWorkstream.showModal);
  const { confirmRefreshModal } = useValidateActionResponse({
    responseError: isResponseError(tagFileWorkstreamMutation.data)
      ? tagFileWorkstreamMutation.data
      : null,
  });
  const selectedWorkstreams = useSelector((store: RootState) =>
    store.tagFileWorkstream.selectedWorkstreams.filter((ws) => !ws.isRemoved)
  );
  const document = {
    id: fileEntry.file.id,
    linkId: fileEntry.file.id,
    origin: fileEntry.file.rawName,
    type: 'document',
    tagWorkstream: fileEntry.workstreams.map((ws) => ({
      id: ws.id,
      value: ws.id,
      color: ws.color,
      label: ws.name,
      isPermanent: ws.isPermanent,
    })),
  };

  useEffect(() => {
    if (showModal) {
      const documents = [document];

      dispatch(
        initialize(documents, {
          tagWorkstreamApi: tagFileWorkstreamMutation.mutateAsync,
          // onSearchWorkstream,
        })
      );
    }
  }, [showModal]);

  const handleClose = () => {
    dispatch(toggleModal(false));
  };

  const handleSave = async () => {
    const selectedWorkstreamIds = selectedWorkstreams.map((ws) => ws.value);

    const response = await tagFileWorkstreamMutation.mutateAsync({
      workstreamIds: selectedWorkstreamIds,
    });

    if (response) {
      // Handle optimistic update away from onSuccess mutation because no workstream id in response
      handleClose();
      showToast('success', 'File successfully tagged to the workstream.');
    }
  };

  const handleShowModal = async () => {
    dispatch(toggleModal(true));
  };

  return (
    <React.Fragment>
      <ActionButton
        id={'tag_document'}
        className={clsx('tw-w-full', 'tw-justify-between')}
        onClick={handleShowModal}
        label={'Add/Edit Tagged Workstream'}
        icon={ICONS.tag}
      />

      {showModal && (
        <ModalPortal>
          {tagFileWorkstreamMutation.isLoading && <Spinner />}
          {tagFileWorkstreamMutation.isLoading && <Spinner />}
          <TagWorkstreamModal
            title="Tag a Workstream to this File"
            onSave={handleSave}
            onClose={handleClose}
          />
        </ModalPortal>
      )}
      {confirmRefreshModal}
    </React.Fragment>
  );
};

export default TagFileWorkstream;
